import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import PetCard, { Pet as DiscoveryPet } from '@/app/pet-discovery/components/PetCard';
import { StaggerContainer, StaggerItem, SlideUp } from '@/components/ui/motion';

interface FeaturedPetsSectionProps {
  pets: any[];
}

const FeaturedPetsSection = ({ pets }: FeaturedPetsSectionProps) => {
  // Helper to map Home pet data to Discovery/PetCard pet data
  const mapToDiscoveryPet = (pet: any): DiscoveryPet => ({
    id: pet.id.toString(),
    name: pet.name,
    species: pet.species || 'Unknown',
    breed: pet.breed,
    age: pet.age,
    size: pet.size || 'Medium', // Default if missing
    gender: pet.gender,
    temperament: pet.traits || [],
    location: pet.location,
    distance: '5 miles', // Mock distance
    image: pet.image,
    alt: pet.alt,
    shelterName: 'Happy Tails Rescue', // Default shelter
    specialNeeds: false,
    vaccinated: true,
    spayedNeutered: true,
    compatibilityScore: Math.floor(Math.random() * (98 - 85) + 85), // Random high score for featured
    quickFacts: []
  });

  const handleCompare = (id: string) => {
    console.log('Compare clicked for', id);
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-semibold text-foreground">
            Meet Your Future Best Friend
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            These wonderful companions are waiting to bring joy, love, and endless memories to your home.
          </p>
        </div>

        <StaggerContainer className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {pets.map((pet) => (
            <StaggerItem key={pet.id}>
              <PetCard
                pet={mapToDiscoveryPet(pet)}
                onCompare={handleCompare}
                isComparing={false}
              />
            </StaggerItem>
          ))}
        </StaggerContainer>

        <div className="text-center mt-12">
          <Link
            href="/pet-discovery"
            className="inline-flex items-center space-x-2 px-8 py-4 bg-primary text-white font-headline font-semibold rounded-lg hover:bg-primary/90 hover:shadow-elevated transition-all duration-300"
          >
            <span>View All Available Pets</span>
            <Icon name="ArrowRightIcon" size={20} variant="outline" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPetsSection;